import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DecisionTrees, Trade } from '../models/decision-tree.model';
import { DECISION_TREES } from '../data/decision-trees.generated';

/** Provides the decision-tree spec baked into the bundle at build time. */
@Injectable({ providedIn: 'root' })
export class DecisionTreeService {
  /** Returns the bundled spec. Observable for API compatibility with consumers. */
  load(): Observable<DecisionTrees> {
    return of(DECISION_TREES);
  }

  /** Trade lookup. Returns null if the trade key is unknown. */
  getTrade(spec: DecisionTrees, tradeId: string): Trade | null {
    if (!tradeId) return null;
    return spec.trades[tradeId.toLowerCase()] ?? null;
  }

  /** List trades in the order the spec defines them (stable per version). */
  listTrades(spec: DecisionTrees): Trade[] {
    return Object.values(spec.trades);
  }
}
